module.exports = __webpack_public_path__ + "img/validatedIcon.6d1fd954.svg";